var cZJ = {};
module.exports = cZJ;